import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listAdminEmails } from '../../../services/adminApi';
import { Tag } from '../catalog/ui';
import '../catalog/catalog.css';
import '../orders/orders.css';
import './ops.css';

// Journal des e-mails (2026-10-23) : tout ce que le site a tenté d'envoyer, une journée à la fois — heure, type, expéditeur,
// destinataire, objet et résultat (parti, refusé, non parti). Le corps des messages n'est jamais conservé.
const TON = { sent: 'ok', failed: 'bad', skipped: 'warn' };

export default function EmailsSection() {
  const { t, i18n } = useTranslation('admin');
  const [jour, setJour] = useState('');
  const [statut, setStatut] = useState('');
  const [q, setQ] = useState('');
  const [recherche, setRecherche] = useState('');
  const [data, setData] = useState(null);
  const [erreur, setErreur] = useState('');

  const charger = useCallback(async () => {
    try {
      setData(await listAdminEmails({ jour, statut, q: recherche }));
      setErreur('');
    } catch (err) { setErreur(err?.message || t('emails.failed')); }
  }, [jour, statut, recherche, t]);
  useEffect(() => { charger(); }, [charger]);

  const heure = (iso) => new Date(iso).toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const jourLisible = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(i18n.language, { weekday: 'short', day: 'numeric', month: 'short' });
  const jourCourant = data ? data.day : jour;

  return (
    <section className="adm-card">
      <h2>{t('emails.title')}</h2>
      <p className="adm-note">{t('emails.subtitle')}</p>

      {data && data.days.length > 0 && (
        <div className="adm-chips" role="group" aria-label={t('emails.days')}>
          {data.days.map((d) => (
            <button key={d.day} type="button" className="adm-chip" aria-pressed={d.day === jourCourant} onClick={() => setJour(d.day)}>
              {d.day === data.today ? t('emails.today') : jourLisible(d.day)} <b>{d.sent + d.failed + d.skipped}</b>
              {d.failed > 0 && <> · <span style={{ color: 'var(--bad)' }}>{t('emails.failedCount', { count: d.failed })}</span></>}
            </button>
          ))}
        </div>
      )}

      <div className="adm-chips" role="group" aria-label={t('emails.statusFilter')}>
        {['', 'sent', 'failed', 'skipped'].map((s) => (
          <button key={s || 'tous'} type="button" className="adm-chip" aria-pressed={statut === s} onClick={() => setStatut(s)}>
            {s ? t(`emails.status.${s}`) : t('emails.all')}
          </button>
        ))}
        <span className="adm-chips-sep" aria-hidden="true" />
        <form onSubmit={(e) => { e.preventDefault(); setRecherche(q.trim()); }} className="adm-inline-search">
          <input className="adm-input" type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('emails.search')} aria-label={t('emails.search')} />
        </form>
        <input className="adm-input" type="date" value={jourCourant || ''} onChange={(e) => setJour(e.target.value)} aria-label={t('emails.pickDay')} style={{ maxWidth: '11rem' }} />
      </div>

      {erreur && <p className="adm-error" role="alert">{erreur}</p>}
      {!data && !erreur && <p className="adm-state" role="status">{t('catalog.common.loading')}</p>}
      {data && data.emails.length === 0 && <p className="adm-note">{t('emails.empty')}</p>}
      {data && data.emails.length > 0 && (
        <div className="adm-tbl">
          <table>
            <thead>
              <tr>
                <th>{t('emails.cols.time')}</th><th>{t('emails.cols.kind')}</th><th>{t('emails.cols.from')}</th>
                <th>{t('emails.cols.to')}</th><th>{t('emails.cols.subject')}</th><th>{t('emails.cols.result')}</th>
              </tr>
            </thead>
            <tbody>
              {data.emails.map((e) => (
                <tr key={e.id}>
                  <td>{heure(e.at)}</td>
                  <td>{e.kind || '—'}</td>
                  <td>{e.from || '—'}</td>
                  <td>{e.to}</td>
                  <td>{e.subject || '—'}</td>
                  <td>
                    <Tag tone={TON[e.status]}>{t(`emails.status.${e.status}`)}</Tag>
                    {e.detail && <small>{t(`emails.reasons.${e.detail}`, { defaultValue: e.detail })}</small>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data && <p className="adm-note">{t('emails.count', { count: data.emails.length })}</p>}
    </section>
  );
}
